import { useTranslation } from "react-i18next";

/**
 * Subtle reach badge for owner surfaces: 👁 views · 👤 unique readers.
 * Renders nothing when both are zero so brand-new books aren't cluttered.
 */
export function ViewCountBadge({ views, readers }: { views?: number; readers?: number }) {
  const { t } = useTranslation();
  const v = views ?? 0;
  const r = readers ?? 0;
  if (v === 0 && r === 0) return null;
  return (
    <span
      className="tp-eyebrow"
      title={`${t("viewCount.views", { count: v })} · ${t("viewCount.readers", { count: r })}`}
      style={{ fontSize: 10, color: "var(--tp-ink-soft)", display: "inline-flex", gap: 8 }}
    >
      <span>👁 {v}</span>
      <span>👤 {r}</span>
    </span>
  );
}
